export default __webpack_public_path__ + "assets/front/scss/user-profile.94da124b57d0b13ae3d64279d1a3eef8.css";